import { FC, memo, Dispatch, SetStateAction, useMemo, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Box, Button, Heading, Stack, Text, useDisclosure } from '@chakra-ui/react'

import MetadatasForm from './components/MetadatasForm'
import MetadatasValues from './components/MetadatasValues'
import FilterTemplate from '../FilterTemplate'

type Props = {
  readMetadatasInfos?: (params?: any) => Promise<any>
  title: string
  description?: string
  metadata: any
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
}

const MetadatasFilterTemplate: FC<Props> = ({ title, description, filter, metadata, setFilter, readMetadatasInfos }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { register, handleSubmit, reset } = useForm()

  const metadatasInfos = useMemo(() => {
    const metadatasValuesFormated = [1, 2, 3, 4, 5, 6, 7].map((number) => {
      const label = metadata[`info_${number}_label`]
      const type = metadata[`info_${number}_data_type`]
      const info = filter[`info_${number}`]
      const rule = filter[`info_${number}_rule`]
      const name = `info_${number}`

      return { label, type, info, rule, name }
    })
    return metadatasValuesFormated.filter(({ label }) => {
      return !!label
    })
  }, [filter, metadata])

  function setMetadataFieldsDefafaultRulesValue() {
    const defaultValues: any = {}

    metadatasInfos.forEach(({ name, info, rule }) => {
      defaultValues[name] = filter[name]
      defaultValues[`${name}_rule`] = rule
      if (info === '') {
        defaultValues[`${name}_rule`] = ''
      }
    })

    reset(defaultValues)
  }

  function onSubmit(newFilter: any) {
    setFilter({ ...filter, ...newFilter })
    onClose()
  }

  useEffect(() => {
    setMetadataFieldsDefafaultRulesValue()
  }, [metadatasInfos])

  if (!metadata?.id) return null

  return (
    <FilterTemplate
      title={title}
      description={description}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      contentWhenClosed={
        <MetadatasValues metadatasInfos={metadatasInfos} onClose={onClose} setFilter={setFilter} filter={filter} metadata={metadata} />
      }
      content={
        <Box as="form" onSubmit={handleSubmit(onSubmit)}>
          {metadatasInfos.length === 0 ? (
            <Stack align="center">
              <Heading>Nenhuma informação complementar</Heading>
              <Text>Este dado não possui informação complementar</Text>
            </Stack>
          ) : (
            <>
              <MetadatasForm
                readMetadatasInfos={readMetadatasInfos}
                metadatasInfos={metadatasInfos}
                metadata={metadata}
                register={register}
                filter={filter}
                setFilter={setFilter}
              />
              <Button mt={4} type="submit" minWidth="100%">
                Pesquisar
              </Button>
            </>
          )}
        </Box>
      }
    />
  )
}

export default memo(MetadatasFilterTemplate)
